import React,{useRef, useState, useEffect, useContext} from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, Badge, InputGroup, Alert, Dropdown } from "react-bootstrap";
import {setUrlParam } from "../utils/functions";
import Select from "react-select";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import Header from "../layouts/Header";
import parse from 'html-react-parser';
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import energyTypes from "../data/energyTypes";
import vindrApi from "../utils/vindrapi";
import authApi from "../utils/authApi";
import Loader from "../components/Loader";
import Filter from "../components/Filter";
import UserMenu		from "../components/UserMenu";
import {formatDate} from  "../utils/functions";
import DialogScreeningMap from "../layouts/DialogScreeningMap";
import InfoLayers from "../components/InfoLayers";
import DialogUploadLayer from "../layouts/DialogUploadLayer";
import {drawUtils} from "../utils/drawUtils";
import drawTheme from "../utils/drawUtilsTheme";
import boundaryMode from "../utils/boundaryMode";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import turbineControl from "../utils/turbineControl";
import limited_simple_select from "../utils/simple_select";
import limited_direct_select from "../utils/direct_select";
import DialogProject from "../layouts/DialogProject";
import TurfCenterOfMass from '@turf/center-of-mass';
import TurfBBox from '@turf/bbox';
import { Trash, Copy, FloppyDisk, UploadSimple, Polygon } from "@phosphor-icons/react";
import EditNow from "../components/EditNow";
import globalContext				from "../utils/globalContext";

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import key from '../data/mapboxKey'; // eslint-disable-line import/no-webpack-loader-syntax


var tc,du, selectedMap;	//Turbine control

export default function SandboxMap() {
	
	document.body.className="sandboxmap";
		
	const [loaded,setLoaded]							= useState(false); //status variable set when all data is loaded
	const [mapLoaded,setMapLoaded]						= useState(false); //status variable set when all data is loaded
	const [user,setUser]								= useState(false);
	const [btnSave,setBtnSave]							= useState(false);
	const [uploadDialog, setUploadDialog]				= useState({open:false}); //displays upload layer dialog
	const [saveProjectDialog, setSaveProjectDialog]		= useState({open:false}); //displays save project dialog
	const params										= useParams();
	
	const context = useContext(globalContext);

	const center = [24.410699837112105, 59.9885433348754];
	const zoom = 5;


	const mapCont										= useRef(null);
	const infoLayerPanel								= useRef(null);
	const map											= useRef(null);



	MapboxDraw.modes.simple_select = {...MapboxDraw.modes.simple_select, ...limited_simple_select};
	MapboxDraw.modes.direct_select = {...MapboxDraw.modes.direct_select, ...limited_direct_select};

	const Draw = new MapboxDraw({
		displayControlsDefault: false,
		controls: {
			polygon: false,
			line_string:false,
			trash: false,
			boundary_mode:true
		},
		userProperties:true,
		styles: drawTheme,
		modes: Object.assign({
			boundary_mode: boundaryMode,
		}, MapboxDraw.modes)
	});

	
	
	const getCopy = () => {
		return JSON.parse(JSON.stringify(this.state.items));
	}

	const getData = () => {

		const id = params.id;

		
		Promise.all([vindrApi.getToken()])
		.then((res) => {
			 
			const dataRequests = [
				authApi.getUser()
			];
			
			return Promise.all(dataRequests);
		}).then((res)=>{
			
			const dataRequests = [
				res[0],
				vindrApi.getUserMaps(res[0].userDetails)
			];
			
			return Promise.all(dataRequests);
		}).then((res)=>{
			
			const sandbox = res[1].find((a)=>{return a.id == id});
			
			
			setUser(res[0]);
			selectedMap = sandbox;
			renderMap();
			setLoaded(true);
			
			document.title = sandbox.title + ' - ' + process.env.REACT_APP_DOC_TITLE;

		}).catch((e)=>{
			setLoaded(true);

		});
		return;

		
	}

	const handleNew = (newMap) => {
		
		var swap = this.getCopy();
		swap.unshift(newMap);
		
		this.updateStatus({items:swap});
	}
	
	const handleUpdate = (id, newTitle) => {
		var swap = this.getCopy();
		var idx = swap.findIndex((i)=>{return i.id == id});

		if(idx != -1){
			swap[idx].title = newTitle;
			this.updateStatus({items:swap});
			vindrApi.updateUserMap(swap[idx]);
		}
	}
	const handleCloseMap = () => {
		this.updateStatus({selectedMap:null, map:null});
		
	}
	const handleDropDownClick = (e) => {
		e.stopPropagation();
	}
	const handleDuplicate = (item) => {
		
		
		Promise.all([vindrApi.duplicateUserMap(item)])
		.then((res) => {
			
			if(Array.isArray(res) && res.length && res[0].id)
				this.handleNew(res[0]);
			
			
		}).catch((e)=>{

		});
		
	}
	const handleDelete = (item) => {
		
		Promise.all([vindrApi.deleteUserMap(item)])
		.then((res) => {
			var swap = getCopy();
			var idx = swap.findIndex((i)=>{return i.id == item.id});
		
			if(idx != -1){
				swap.splice(idx, 1);
				this.updateStatus({items:swap});
			}
			
		}).catch((e)=>{

		});
		
	}
	const updateMapSettings = (newSettings) => {
		if(!selectedMap)
			return;
		
		var newMap = {...selectedMap, ...newSettings};
		
		selectedMap = newMap;
		
		vindrApi.updateUserMap(newMap);

	}

	const renderMap = () => {
		
		if(map.current)
			return;
		
		var self = this;
		map.current = new mapboxgl.Map({
			container: mapCont.current,
			style: 'mapbox://styles/espenvindr/cljhhkw0z000901pq5tql7ice',
			center: center,
			zoom: zoom,
		});
		
		map.current.addControl(Draw, 'bottom-left');
		
		map.current.dragRotate.disable();
		
		du		= new drawUtils(map.current, Draw);
		tc		= new turbineControl(map.current, du);
		
		context.tc = tc;
		
		map.current.on('draw.create', (e)=>{setBtnSave(true)});
		map.current.on('draw.delete', (e)=>{setBtnSave(false)});
		map.current.on('draw.modechange', (e)=>{du.handleModeChange(e);});
		
		map.current.on('load', () => {
			
			setMapLoaded(true);
			showSandbox();
		});
		
		
		
		
	}
	const showSandbox = () => {
		if(!selectedMap)
			return;
		
		var target = {};
		
		if(!isNaN(selectedMap.settings.lng) && !isNaN(selectedMap.settings.lat))
			target = {center:[selectedMap.settings.lng, selectedMap.settings.lat]};
		if(!isNaN(selectedMap.settings.zoom))
			target = {...target, ...{ zoom:selectedMap.settings.zoom}};
		
		if(target.center)
			map.current.setCenter(target.center).setZoom(target.zoom);
		
		
		
		map.current.once('zoomend', () => {
			map.current.on('zoomend', () => {
				var settings = {
					...selectedMap.settings, 
					...{zoom:map.current.getZoom()}
				};
				updateMapSettings({...selectedMap, ...{settings: settings}});
			});
			map.current.on('dragend', () => {
				var coords = map.current.getCenter();
				var settings = {
					...selectedMap.settings, 
					...coords
				};
				updateMapSettings({...selectedMap, ...{settings: settings}});
			});
		});
	}
	const drawProject = (e) => {
		if(tc)
			tc.addProject(e);
	}

	const openUploadLayer = () => {
		setUploadDialog({open:true});
	}
	const closeUploadLayer = () => {
		setUploadDialog({open:false});
	}
	const openSaveProject = (b) => {
		setSaveProjectDialog({open:true, boundary:b});
	}
	const closeSaveProject = () => {
		setSaveProjectDialog({open:false});
	}
	
	const handleSaveProject = (e) => {
		
		var fc = du.draw.getAll();
		
		if(!fc.features || !fc.features.length)
			return;
		
		var b = {...fc.features[0].geometry};
		
		if(fc.features[0].geometry.type != 'MultiPolygon'){
			b.type = 'MultiPolygon';
			b.coordinates = [fc.features[0].geometry.coordinates];
		}
		openSaveProject(b);
	}
	
	const handleLayerUpload = (layer) => {
		
		if(this.du && layer.features && layer.features.length){
			
			var feature = {...layer.features[0]};
			
			const center = TurfCenterOfMass(feature.geometry).geometry.coordinates;
			
			
			feature.id = 'boundary';
			
			
			this.du.draw.add(feature);
			this.updateStatus({saveBtn:true})
			this.state.map.fitBounds(TurfBBox(feature));
			this.state.map.flyTo({
				center: center
			});
		}
		
	}
	const renderLayers = () => {
		if(!mapLoaded)
			return;
		return (
			<div className="nav-group project-panel show">
				<div id="layers" className="layer-section	mt-3">
					 <InfoLayers ref={infoLayerPanel} context={context} scenario={{layers:selectedMap.layers, scenario_id:0}} onChange={(payload)=>{updateMapSettings({layers:payload})}} user={user} map={map}  />
				</div>
			</div>
		 );
	}



	useEffect(()=>{
		getData();
	},[]);
	
	
	return (
		<>


			<div className="header">

				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>



				<div className="middle">
					{!!selectedMap &&
					<Link className="header-logo">{selectedMap.title}</Link>
					}

				</div>

				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/vindr_logo_blue.svg" alt="Vindr"/>
				</div>
				<div className="options">
					<Link to="/pages/sandbox/" className="btn btn-outline-primary">Close</Link>
					
					
				</div>
			</div>
			<div className="body">
				<Sidebar onClick={(e)=>{ e.stopPropagation();}} add={renderLayers()} hideMenu={true} />
				<div className={"main sandbox "}>
					<Row className="mb-4">
						<Col xl>

						</Col>
					</Row>

					<div ref={mapCont}	className="project-map" >

						<div className="screening-cp">
							<Button className="add-project" onClick={drawProject} variant="light">Draw project <Polygon weight="bold" size={16} /></Button>
							<Button className="upload-project" onClick={openUploadLayer} variant="light">Upload project <UploadSimple weight="bold" size={16} /></Button>
							{
							btnSave && <Button  onClick={handleSaveProject} variant="success">Save project <FloppyDisk weight="bold" size={16} />    </Button>
							}
						</div>
						<DialogUploadLayer setup={uploadDialog} title="Upload project" type="convertLayer" onUpload={handleLayerUpload} onClose={closeUploadLayer} />
						<DialogProject user={user} state={saveProjectDialog} onClose={closeSaveProject} />

					</div>


				</div>


			</div>
			<Loader loaded={loaded} message="Loading project..." />
		</>
	);
	
}